var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRent = function SvgRent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 61,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rent_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCAA1",
    d: "M34.648 18.63c0-1.33-1.119-2.411-2.493-2.411h-2.31c-1.375 0-2.493 1.082-2.493 2.412v5.824h7.295zM50.678 51.519H11.322v-9.413h39.356z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "m14.558 34.078 4.052 4.455M12.53 29.2v9.334M18.61 31.625c0 1.34-1.215 2.426-2.65 2.426-.71 0-3.409.01-3.409.01s-.011-1.76-.011-2.436c0-.555-.007-2.426-.007-2.426h3.428c1.434 0 2.648 1.086 2.648 2.426M31.984 38.534V29.14l7.296 9.474v-9.492M27.418 29.164h-3.945v9.37h3.945M27.12 33.79h-3.647M44.143 29.121h5.327M46.796 29.418v9.115"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M51.077 59.754H10.923c-2.006 0-3.632-1.574-3.632-3.516V5.613c0-1.941 1.626-3.515 3.632-3.515h40.154c2.007 0 3.633 1.574 3.633 3.515v50.625c0 1.942-1.626 3.516-3.633 3.516"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M20.683 13.259 31 6.805l10.317 6.454"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E3037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M38.296 11.367v13.086h-14.59V11.367M29.784 12.688h2.432M12.53 55.047h36.94"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rent_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .926h62v60H0z"
  })))));
};
export default SvgRent;